import "./sentry";

import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./App.css";
import "./styles/custom.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorGeneric from "./pages/Error/components/ErrorGeneric";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="*"
      element={<AppRoutes />}
      errorElement={
        <ErrorGeneric
          errorTitle="Something went wrong"
          errorDescription="An unexpected error occurred. Please try refreshing the page or come back later."
          errorImage="/error500.svg"
        />
      }
    />
  )
);

const App: React.FC = () => {
  return (
    <>
      <div className="App">
        <ToastContainer
          theme=""
          toastClassName="!bg-gray-900 !text-white !shadow-lg"
          bodyClassName="text-sm font-medium"
        />
        <RouterProvider router={router} />
      </div>
    </>
  );
};

export default App;
